const errors = {
    FACTORY_NOT_FOUND: "找不到工廠"
};

export default errors;
